// Code review - In Progress
// Documentation - In Progress
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import * as XLSX from "sheetjs-style";
import {
  projectMasterExportHeaders,
  CommodityCategoryHeaders,
} from "../components/HeaderAttribute";
import toast from "react-hot-toast";
import CommodityCategoryPopup from "../popup-containers/CommodityCategorypopup";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import ProjectPopup from "../popup-containers/ProjectPopup";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import { useUserCapability } from "../components/ConstantReducerProvider";
import TextArea from "../ReusableComponents/TextArea";
const CommodityCategory = () => {
  const location = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  // All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);

  const [addScreenTitle, setAddScreenTitle] = useState(true);   // 👈 change
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Services Category Master insert and edit useState hooks handling .
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [bindCategoryCommodities, setbindCategoryCommodities] = useState([]);
  const [branchProject, setBranchProject] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [Project, setProject] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setdescriptionError] = useState("");
  const [mstProjectId, setMstProjectId] = useState("");
  const [projectError, setProjectError] = useState("");
  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  // All bind data value useState hooks handling.
  const [bindProjectDatas, setBindProjectDatas] = useState([]);
  const [ProjectData, setProjectData] = useState("");
  const [bindBranchProject, setBindBranchProject] = useState([]);

  const [commodityCategory, setCommodityCategory] = useState("");
  const [commodityCategoryError, setCommodityCategoryError] = useState("");

  const [mstCommodityCategoryId, setMstCommodityCategoryId] = useState(0);

  const [mstCommodityTypeId, setMstCommodityTypeId] = useState("");
  const [commodityTypeError, setCommodityTypeError] = useState("");

  // Rowindex, Popup, Pagination, next page and other some useState hooks handling.
  const [rowIndex, setRowIndex] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);

  // Language translate useState hooks handling.
  const [languageCodeKey, setLanguageCodekey] = useState([]);
  const [languageGetCode, setLanguageGetCode] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  // This function is helping for Language translation .
  useEffect(() => {
    const getLanguageCode = async () => {
      const response = await BindAPI("LanguageAPI/GetLanguage");
      setLanguageCodekey(response.data.Table);
    };
    getLanguageCode();
  }, []);

  useEffect(() => {
    const BindAllmasterData = async () => {
      const bindReferredBydatadrp = await BindAPI("LocationAPI/GetLocation");
      const filteredData = bindReferredBydatadrp.data.Table;
      const filteredWithBlockedByNull = filteredData.filter(
        (item) => item.BlockedBy === null
      );

      //   bindCommodityTypeDropdown(filteredWithBlockedByNull);
    };
    BindAllmasterData();
  }, []);

  //   const BindCategoryCommodities = async (resultdata) => {
  //     try {
  //       if (resultdata.length > 0) {
  //         const CategoryDD = resultdata.map((m) => ({
  //           value: m.MstLocationId,
  //           label: m.LocationName_en,
  //         }));
  //         setbindCategoryCommodities(CategoryDD);
  //       } else {
  //         setbindCategoryCommodities([]);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching state data:", error);
  //     }
  //   };

  useEffect(() => {
    const bindCommodityTypeDropdown = async () => {
      try {
        const response = await BindAPI(
          "CategoryCommoditiesAPI/BindCommodityType"
        );

        const data = response?.data?.Table || [];

        const dropdownData = data.map((item) => ({
          value: item.MstCommodityTypeId,
          label: item.CommodityType_en,
        }));

        setbindCategoryCommodities(dropdownData);
      } catch (error) {
        console.error("Dropdown binding error:", error);
        setbindCategoryCommodities([]);
      }
    };

    bindCommodityTypeDropdown();
  }, []);

  useEffect(() => {
    var languageKeys = languageCodeKey.map((item) => item.LanguageKey);
    setLanguageGetCode(languageKeys);
  }, [languageCodeKey]);

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  // This function is helping for Popup close .
  const handleClose = () => {
    setpopUpOpen(false);
  };

  // This function is helped to the viwe, delete, block and unblock
  // input value via rowindex passing for Services Category .
  const handleServiceCategory = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    const projectData = bindProjectDatas[rowIndex];
    //Location DropDown Value Start
    const locationDropDownValue = bindBranchProject.find(
      (item) => item.value === projectData.MstCommodityCategoryId
    );
    const editLocationDropDownValue = {
      value: projectData.MstCommodityCategoryId,
      label: CommodityCategory ? CommodityCategory.label : "Unknown",
    };
    const autoDropDownValues = [editLocationDropDownValue];
    setPopUpDropDownData(autoDropDownValues);
    setProjectData(bindProjectDatas[rowIndex]);
  };

  // This function is helped to edit the input value via rowindex passing and helping
  // to visible handling for Services Category.
  const handleEdit = (rowIndex) => {
    const data = bindProjectDatas[rowIndex];

    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    // Correct bindings for edit mode
    setMstCommodityCategoryId(data.MstCommodityCategoryId);
    setCommodityCategory(data.CommodityCategory_en);
    setMstCommodityTypeId(data.MstCommodityTypeId);
    setDescription(data.Description || "");

    // Clear errors
    setCommodityCategoryError("");
    setCommodityTypeError("");
  };
  // This is Services Category grid page add button visible handling functionality .
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setCommodityCategory("");
    setMstCommodityTypeId("");
    setDescription("");
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = () => {
    setSubmitBtnDisabled(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);

    // Clear form values
    setCommodityCategory("");
    setMstCommodityTypeId("");
    setDescription("");

    // Clear errors properly
    setCommodityCategoryError("");
    setCommodityTypeError("");

    setProjectError("");
    setBranchProjectError("");

    // Close error popup
    setIsOpen(false);

    fetchProjectData();
    setIsLoading(false);

  };

  // This function is helped to the edit, viwe, delete, block and unblock flag passing and hanling the API
  // response for those all and passing the rowindex for Services Category.
  const createdBy = sessionStorage.getItem("createdBy");



  const handleSubmit = async (items, flag) => {

    setSubmitBtnDisabled(true);
    setIsLoading(true);

    if (flag === 1 || flag === 2) {
      // Validation
      let categoryValidate = commodityCategory.length > 0 ? "" : "Enter Commodity Category";
      setCommodityCategoryError(categoryValidate);

      let typeValidate = mstCommodityTypeId ? "" : "Select Commodity Type";
      setCommodityTypeError(typeValidate);

      if (categoryValidate || typeValidate) {
        setIsOpen(true);
        setSubmitBtnDisabled(false);
        setIsLoading(false);
        return;
      }

      setIsOpen(false);

      // Language translation
      const languageKeys = ["ta", "hi", "mr", "gu", "kn", "ml", "te", "bn", "or"];
      const translatedTexts = [];

      for (let lang of languageKeys) {
        const res = await LanguageTranslatorAPI(commodityCategory, lang);
        translatedTexts.push(res.data.data.translations[0].translatedText);
      }

      const commodityCategoryPayload = {
        mstCommodityCategoryId: mstCommodityCategoryId ? mstCommodityCategoryId : 0,
        mstCommodityTypeId: mstCommodityTypeId,
        commodityCategory_en: commodityCategory,
        commodityCategory_ta: translatedTexts[0],
        commodityCategory_hi: translatedTexts[1],
        commodityCategory_mr: translatedTexts[2],
        commodityCategory_gu: translatedTexts[3],
        commodityCategory_kn: translatedTexts[4],
        commodityCategory_ml: translatedTexts[5],
        commodityCategory_te: translatedTexts[6],
        commodityCategory_bn: translatedTexts[7],
        commodityCategory_or: translatedTexts[8],
        description: description,
        createdBy: parseInt(createdBy),
        flag: flag
      };

      const response = await IUDAPI(
        commodityCategoryPayload,
        "CategoryCommoditiesAPI/IUDCategoryCommodities"
      );

      if (flag === 1) {
        if (response.data.Table[0].Result === "S") {
          toast.success("Commodity Category added successfully 👍", { duration: 1000 });
          await fetchProjectData();
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to add Commodity Category 👎", { duration: 2000 });
        }
      }

      if (flag === 2) {
        if (response.data.Table[0].Result === "M") {
          toast.success("Commodity Category updated successfully 👍", { duration: 1000 });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to update Commodity Category 👎", { duration: 2000 });
        }
      }
    }
    else {
      // Delete / Block / Unblock
      const commodityCategoryPayload = {
        mstCommodityCategoryId: bindProjectDatas[items].MstCommodityCategoryId,
        createdBy: createdBy,
        flag: flag
      };

      const response = await IUDAPI(
        commodityCategoryPayload,
        "CategoryCommoditiesAPI/IUDCategoryCommodities"
      );

      if (flag === 3 && response.data.Table[0].Result === "D") {
        toast.success("Commodity Category deleted successfully 🗑️");
        cancel();
      }

      if (flag === 4 && response.data.Table[0].Result === "B") {
        toast.success("Commodity Category blocked successfully 🚫");
        cancel();
      }

      if (flag === 5 && response.data.Table[0].Result === "UB") {
        toast.success("Commodity Category unblocked successfully ✅");
        cancel();
      }
    }

    setSubmitBtnDisabled(false);
    setIsLoading(false);
  };

  const fetchProjectData = async () => {
    try {
      setIsLoading(true);

      const response = await BindAPI(
        "CategoryCommoditiesAPI/BindCategoryCommodities"
      );

      setBindProjectDatas(response?.data?.Table || []);
    } catch (error) {
      console.error("Grid bind error:", error);
      setBindProjectDatas([]);
    } finally {
      setIsLoading(false);
    }
  };

  // This hook function is helped to bind all data from Services Category master table.
  useEffect(() => {
    fetchProjectData();
  }, []);

  //   const fetchProjectData = async () => {
  //     setIsLoading(true);
  //     if (userProfileDatas && userProfileDatas[0]) {
  //       const data = {
  //         mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
  //         mstBranchId: userProfileDatas[0]?.MstLocationId,
  //         mstSdpId: userProfileDatas[0].MstSDPId
  //           ? userProfileDatas[0].MstSDPId
  //           : 0,
  //         mstUserId: userProfileDatas[0]?.MstUserId,
  //         mstRoleId: userProfileDatas[0]?.MstRoleId,
  //       };
  //       const response = await BindPostAPI(data, "ProjectAPI/BindProjectGrid");

  //       setBindProjectDatas(response.data.Table);
  //     }

  //     setIsLoading(false);
  //   };

  useEffect(() => {
    if (location.pathname == "/project") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      fetchProjectData();
    }
  }, [location]);


  const CommodityCategoryHeadersExcel = [
    "S.no",
    "MstCommodityCategoryId",
    "Commodity Type",
    "Category_en",
    "Category_ta",
    "Category_hi",
    "Category_mr",
    "Category_gu",
    
    "Category_kn",
    "Category_ml",
    
    
    "Category_te",
    "Category_bn",
    "Category_or",
    "Description",
    "Created By Name",
  ];

  /* ================= EXPORT HANDLER ================= */
  const handleExport = async () => {
    try {
      const res = await BindAPI(
        "CategoryCommoditiesAPI/BindCategoryCommoditiesExcel"
      );

      const rows = res?.data?.Table || [];

      if (rows.length === 0) {
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }

      exportData(CommodityCategoryHeadersExcel, rows);
    } catch (error) {
      console.error("Excel export error:", error);
      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Commodity Category Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const baseStyle = isAlt
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle },                    // S.No
        { v: row.MstCommodityCategoryId, s: baseStyle },
        { v: row.CommodityType_en, s: baseStyle },
        { v: row.CommodityCategory_en, s: baseStyle },
        { v: row.CommodityCategory_ta, s: baseStyle },
        { v: row.CommodityCategory_hi, s: baseStyle },
        { v: row.CommodityCategory_mr, s: baseStyle },
        { v: row.CommodityCategory_gu, s: baseStyle },
        
        { v: row.CommodityCategory_kn, s: baseStyle },
        { v: row.CommodityCategory_ml, s: baseStyle },
        
        
        { v: row.CommodityCategory_te, s: baseStyle },
        { v: row.CommodityCategory_bn, s: baseStyle },
        { v: row.CommodityCategory_or, s: baseStyle },
        { v: row.Description || "", s: baseStyle },
        { v: row.CreatedByName, s: baseStyle },             // Created By
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 6 },
      { width: 30 },
      { width: 30 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 35 },
      { width: 40 },
      { width: 30 },
    ];

    /* ================= BORDERS ================= */
    const applyBorders = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyBorders(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Commodity Category");
    XLSX.writeFile(wb, "Commodity_Category_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Commodity Category"
          header={CommodityCategoryHeaders}
          records={bindProjectDatas}
          handleEdit={handleEdit}
          handleAction={handleServiceCategory}
          showAdd={showAdd}
          handleExportBtn={true}
          handleExport={handleExport}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="Commodity Category"
          />
          <div class={mainTable.firstMainAddScreen}>
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <div>
                      {/* <AutoDropDown
  classStar="text-red-500"
  title={"Commodity Type"}
  options={BindCategoryCommodities}
  placeholder={"Select"}
  name={"commodityCategory"}
  selectedOption={
    branchProject
      ? BindCategoryCommodities.find((x) => x.value == branchProject)
      : ""
  }
  controlFunc={(value) => {
    setBranchProject(value.value);
    setBranchProjectError(
      value ? "" : "Select Commodity Category"
    );
  }}
  controlFuncBlur={() => {
    setBranchProjectError(
      branchProject ? "" : "Select Commodity Category"
    );
  }}
  Class="custom-class"
  tabIndex="1"
/> */}


                      {/* <AutoDropDown
  classStar="text-red-500"
  title={"Commodity Type"}
  options={bindCategoryCommodities}
  placeholder={"Select"}
  name={"commodityCategory"}
  selectedOption={
    branchProject
      ? bindCategoryCommodities.find((x) => x.value === branchProject)
      : ""
  }
  controlFunc={(value) => {
    setBranchProject(value.value);
    setBranchProjectError(value ? "" : "Select Commodity Type");
  }}
  controlFuncBlur={() => {
    setBranchProjectError(branchProject ? "" : "Select Commodity Type");
  }}
  Class="custom-class"
  tabIndex="1"
/> */}

                      <AutoDropDown
                        classStar="text-red-500"
                        title={"Commodity Type"}
                        options={bindCategoryCommodities}
                        placeholder={"Select"}
                        name={"commodityType"}
                        selectedOption={
                          mstCommodityTypeId
                            ? bindCategoryCommodities.find((x) => x.value === mstCommodityTypeId)
                            : ""
                        }
                        controlFunc={(value) => {
                          setMstCommodityTypeId(value.value);      // ✅ correct
                          setCommodityTypeError(value ? "" : "Select Commodity Type");
                        }}
                        controlFuncBlur={() => {
                          setCommodityTypeError(mstCommodityTypeId ? "" : "Select Commodity Type");
                        }}
                        Class="custom-class"
                        tabIndex="1"
                        errorMessage={commodityTypeError?.commodityTypeError}
                        setError={setCommodityTypeError}
                      />

                      {/* {commodityTypeError && (
  <span className="text-red-500">{commodityTypeError}</span>
)} */}
                    </div>
                    {/* <InputText
  classStar="text-red-500"
  inputType={"text"}
  title={"Category"}
  name={"Category"}
  content={Project}
  controlFunc={(e) => {
    const value = e.target.value;
    setProject(value);
    setProjectError(
      value.length > 0 ? "" : "Enter Category"
    );
  }}
  controlFuncBlur={(e) => {
    const trimmedValue = e.target.value.trim();
    setProject(trimmedValue);
    setProjectError(
      trimmedValue.length > 0 ? "" : "Enter Category"
    );
  }}
/> */}


                    {/* {projectError && (
                      <span class="text-red-500">{projectError}</span>
                    )} */}

                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Category"}
                      name={"Category"}
                      content={commodityCategory}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setCommodityCategory(value);
                        setCommodityCategoryError(value.length > 0 ? "" : "Enter Category");
                      }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setCommodityCategory(trimmedValue);
                        setCommodityCategoryError(
                          trimmedValue.length > 0 ? "" : "Enter Category"
                        );
                      }}

                      errorMessage={commodityCategoryError}
                    />



                    <TextArea
                      title="Description"
                      name="description"
                      rows={4}
                      content={description}
                      controlFunc={(e) => setDescription(e.target.value)}
                      errorMessage={descriptionError}
                      description="Enter a brief explanation about this category. Maximum 250 characters."
                    />

                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleServiceCategory}
      >
        <div className=" flex flex-col gap-3">
          <PopUpScreenTitle
            title="CommodityCategory"
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <CommodityCategoryPopup data={ProjectData}


            data1={bindCategoryCommodities} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default CommodityCategory;
